export const addAnalyticsClickPdpImageVideo = data => {
  const {
    index = 0,
    mediaType = "",
    imageVideoName = "",
    totalImages = 0,
    pdpType = "",
    assetId = "",
  } = data

  const { adobeDataLayer: {} = {} } = window

  const imageVideoIdKey = mediaType === "image reel" ? "imageId" : "videoId"
  const imageVideoNameKey =
    mediaType === "image reel" ? "imageName" : "videoName"

  const eventInfo = {
    eventAction: `pdp:product details:${mediaType}`,
    eventName: `pdp:product details:${mediaType}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: assetId,
    internalLinkPosition: `pdp${pdpType === "bundle" ? ":bundle" : ""}`,
    internalLinkType: `pdp:${mediaType}`,
    internalLinkZoneName: "pdp:product details",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
    imageSequence: `${index}_${totalImages}`,
    [imageVideoIdKey]: assetId,
    [imageVideoNameKey]: imageVideoName,
  }

  pushAnalyticsObjToDataLayer(eventInfo)
}

export const addAnalyticsClickSliderImageVideo = data => {
  const {
    index = 0,
    imageVideoId = "n/a",
    totalImages = 0,
    pdpType = "",
    zoomEntryPoint = "image reel",
    imageName = "n/a",
    imageClick = false,
  } = data
  const { adobeDataLayer: {} = {} } = window
  const imageVideoIdKey = imageClick ? "imageId" : "videoId"
  const imageVideoNameKey = imageClick ? "imageName" : "videoName"
  const eventInfo = {
    eventAction: "pdp:product details:carousel image click",
    eventName: "pdp:product details:carousel image click",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: imageVideoId,
    internalLinkPosition: `pdp${pdpType === "bundle" ? ":bundle" : ""}`,
    internalLinkType: `pdp:${zoomEntryPoint}`,
    internalLinkZoneName: "pdp:product details:view gallery",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
    imageSequence: `${index}_${totalImages}`,
    [imageVideoIdKey]: imageVideoId,
    [imageVideoNameKey]: imageName ? imageName.toLowerCase() : "n/a",
  }

  pushAnalyticsObjToDataLayer(eventInfo)
}

export const addAnalyticsClickCloseZoom = data => {
  const {
    pdpType = "",
    zoomEntryPoint = "image reel",
    currentImageData = {},
    totalImages = "",
  } = data

  const {
    type: mediaType = "",
    assetId: mediaAssetId = "",
    url: mediaAssetURL = "",
    label: mediaLabel = "n/a",
    index: mediaIndex = "",
  } = currentImageData

  const assetId = mediaAssetId || mediaAssetURL
  const { adobeDataLayer: {} = {} } = window
  const imageVideoIdKey = !mediaType ? "imageId" : "videoId"
  const imageVideoNameKey = !mediaType ? "imageName" : "videoName"
  const eventInfo = {
    eventAction: "pdp:product details:carousel image click:close button",
    eventName: "pdp:product details:carousel image click:close button",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "close",
    internalLinkPosition: `pdp${pdpType === "bundle" ? ":bundle" : ""}`,
    internalLinkType: `pdp:${zoomEntryPoint}`,
    internalLinkZoneName: "pdp:product details:view gallery",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
    [imageVideoIdKey]: assetId,
    [imageVideoNameKey]: mediaLabel ? mediaLabel.toLowerCase() : "n/a",
    imageSequence: `${mediaIndex + 1}_${totalImages}`,
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const addAnalyticsClickZoomReset = data => {
  const {
    pdpType = "",
    zoomEntryPoint = "image reel",
    currentImageData = {},
    totalImages = "",
  } = data

  const {
    type: mediaType = "",
    assetId: mediaAssetId = "",
    url: mediaAssetURL = "",
    label: mediaLabel = "n/a",
    index: mediaIndex = "",
  } = currentImageData

  const assetId = mediaAssetId || mediaAssetURL
  const { adobeDataLayer: {} = {} } = window
  const imageVideoIdKey = !mediaType ? "imageId" : "videoId"
  const imageVideoNameKey = !mediaType ? "imageName" : "videoName"
  const eventInfo = {
    eventAction: "pdp:product details:carousel image click:zoom reset",
    eventName: "pdp:product details:carousel image click:zoom reset",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "zoom reset:applied",
    internalLinkPosition: `pdp${pdpType === "bundle" ? ":bundle" : ""}`,
    internalLinkType: `pdp:${zoomEntryPoint}`,
    internalLinkZoneName: "pdp:product details:view gallery",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
    [imageVideoIdKey]: assetId,
    [imageVideoNameKey]: mediaLabel ? mediaLabel.toLowerCase() : "n/a",
    imageSequence: `${mediaIndex + 1}_${totalImages}`,
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const addAnalyticsZoomImageSliderArrow = data => {
  const {
    pdpType = "",
    zoomEntryPoint = "image reel",
    arrowLable = "right",
  } = data

  const { adobeDataLayer: {} = {} } = window

  const eventInfo = {
    eventAction: `pdp:product details:carousel image click:${arrowLable}`,
    eventName: `pdp:product details:carousel image click:${arrowLable}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: `${arrowLable} arrow`,
    internalLinkPosition: `pdp${pdpType === "bundle" ? ":bundle" : ""}`,
    internalLinkType: `pdp:${zoomEntryPoint}`,
    internalLinkZoneName: "pdp:product details:view gallery",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }

  pushAnalyticsObjToDataLayer(eventInfo)
}

export const addAnalyticsClickZoomImage = data => {
  const {
    pdpType = "",
    zoomEntryPoint = "image reel",
    zoomAction = "zoom in",
    currentImageData = {},
    totalImages = 0,
    counter,
  } = data

  const { adobeDataLayer: {} = {} } = window

  const {
    assetId: mediaAssetId = "",
    url: mediaAssetURL = "",
    label: mediaLabel = "n/a",
    index: mediaIndex = "",
  } = currentImageData

  const assetId = mediaAssetId || mediaAssetURL
  const eventInfo = {
    eventAction: `pdp:product details:carousel image click:${zoomAction}`,
    eventName: `pdp:product details:carousel image click:${zoomAction}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: `${zoomAction}:applied`,
    internalLinkPosition: `pdp${pdpType === "bundle" ? ":bundle" : ""}`,
    internalLinkType: `pdp:${zoomEntryPoint}`,
    internalLinkZoneName: "pdp:product details:view gallery",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
    imageId: assetId,
    imageName: mediaLabel ? mediaLabel.toLowerCase() : "n/a",
    imageSequence: `${mediaIndex + 1}_${totalImages}`,
    zoomUsageDepth: `${zoomAction}_${counter}`,
  }

  pushAnalyticsObjToDataLayer(eventInfo)
}

export const addAnalyticsPdpSlider = data => {
  const {
    pdpImageInfo = {},
    totalImages = 0,
    pdpType = "",
    arrowLabel = "right",
  } = data

  const {
    label: imageName = "n/a",
    index: imageIndex = 0,
    type: imageType = "",
    assetId: imageAssetId = "",
    url: imageUrl = "",
  } = pdpImageInfo

  const { adobeDataLayer: {} = {} } = window

  const imageVideoIdKey = imageType !== "video" ? "imageId" : "videoId"
  const imageVideoNameKey = imageType !== "video" ? "imageName" : "videoName"

  const eventInfo = {
    eventAction: `pdp:product details:slider image click:${arrowLabel}`,
    eventName: `pdp:product details:slider image click:${arrowLabel}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: `${arrowLabel} arrow`,
    internalLinkPosition: `pdp${pdpType === "bundle" ? ":bundle" : ""}`,
    internalLinkType: "pdp:image reel",
    internalLinkZoneName: "pdp:product details:image reel",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
    imageSequence: `${imageIndex + 1}_${totalImages}`,
    [imageVideoIdKey]: imageType !== "video" ? imageAssetId : imageUrl,
    [imageVideoNameKey]: imageName.toLowerCase(),
  }

  pushAnalyticsObjToDataLayer(eventInfo)
}

const pushAnalyticsObjToDataLayer = (eventInfo = {}) => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const event = "cmp:click"
  const { productInfo } = page
  window.adobeDataLayer.push({
    event,
    eventInfo,
    page,
    productInfo,
  })
}
